module.exports = __webpack_public_path__ + "img/cooperation1.d250ed6c.png";